module.exports = __webpack_public_path__ + "img/auth-助考之星-山河医学网授权书.d0c22e39.jpg";